import { ExternalLink } from "../../../../src/components/ExternalLink.js";
import * as React from 'react';
export default {
  ExternalLink,
  React
};